import { FormModal } from "../modals/FormModal";

type ActionType =
  | "activate"
  | "deactivate"
  | "revoke-sessions"
  | "cancel-deletion";

const ACTION_LABELS: Record<ActionType, string> = {
  activate: "Aktywuj konto",
  deactivate: "Dezaktywuj konto",
  "revoke-sessions": "Unieważnij sesje",
  "cancel-deletion": "Anuluj usunięcie",
};

const ACTION_DESCRIPTIONS: Record<ActionType, string> = {
  activate: "Użytkownik będzie mógł się ponownie zalogować.",
  deactivate: "Użytkownik nie będzie mógł się zalogować.",
  "revoke-sessions": "Wymusi wylogowanie ze wszystkich urządzeń.",
  "cancel-deletion": "Anuluje zaplanowane usunięcie konta.",
};

type Props = {
  open: boolean;
  action: ActionType | null;
  email: string;
  busy: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export function UserActionModal({
  open,
  action,
  email,
  busy,
  onClose,
  onConfirm,
}: Props) {
  if (!action) {
    return null;
  }

  return (
    <FormModal
      open={open}
      onClose={onClose}
      title={ACTION_LABELS[action]}
      testId="admin-user-action-modal"
    >
      <p>
        {ACTION_DESCRIPTIONS[action]} Kontynuować dla <strong>{email}</strong>?
      </p>
      <div className="modal__actions">
        <button type="button" className="btn btn--ghost" onClick={onClose} disabled={busy}>
          Anuluj
        </button>
        <button
          type="button"
          className="btn"
          onClick={onConfirm}
          disabled={busy}
        >
          {busy ? "Wykonywanie…" : ACTION_LABELS[action]}
        </button>
      </div>
    </FormModal>
  );
}
